import { Stack, Typography } from '@mui/material';
import { FunctionComponent } from 'react';
import { ConditionLink, ImportedConditionLink } from '@/models/conditionLink';
import { ConditionLinkGeneralDataCard } from '@/pages/rulesets/components/ConditionLinkGeneralDataCard';

type ConditionLinkGeneralDataProps = {
    conditionLink: ConditionLink | ImportedConditionLink;
};

export const ConditionLinkGeneralData: FunctionComponent<
    ConditionLinkGeneralDataProps
> = ({ conditionLink }) => {
    return (
        <Stack spacing={2}>
            <Typography
                sx={{
                    width: '75%',
                }}
            >
                Hier lassen sich allgemeine Daten für das Regelwerk festlegen.
                Bitte beachten: Um eine Kontingent- oder Preisregel zu
                erstellen, muss zuerst ein Name für das Regelwerk angegeben und
                gespeichert werden.
            </Typography>

            <ConditionLinkGeneralDataCard conditionLink={conditionLink} />
        </Stack>
    );
};
